/**
 * Utility function to conditionally add data-testid attributes
 * Only adds the attribute when NODE_ENV is 'test'
 * This prevents test attributes from appearing in production builds
 */
export const getTestId = (id: string) => {
  return process.env.NODE_ENV === "test" ? { "data-testid": id } : {};
};
